import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, ViewChild}      from '@angular/core';
import {
  ApDynComponentComponent
}                                                                                  from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase
}                                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {BehaviorSubject, combineLatest, Observable, Subscription}                  from 'rxjs';
import {
  CampaignYearStore
}                                                                                  from '../../stores/login/campaignyear.store';
import {
  ApDynGridDetailsGridConfig
}                                                                                  from '../../ap-dyngrids/config/details/ap-dyn-grid-details-grid-config';
import {
  PpNoDataValue
}                                                                                  from '../types/pp-planning-booking.types';
import {
  ApDynGridPagerConfigBase
}                                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {IPpOverviewDetailsGridItem, IPpOverviewGridItem, PpOverviewMassEditAction} from '../types/pp-overview.types';
import {PpCommonService}                                                           from '../services/pp-common.service';
import {
  PpOverviewGridConfig
}                                                                                  from '../configs/pp-overview-grid.config';
import {filter, map}                                                               from 'rxjs/operators';
import {
  CropTypeStore
}                                                                                  from '../../stores/base-data/crop.types.store';
import {FieldStore}                                                                from '../../stores/farm/field.store';
import {
  ApDynGridPagerConfig,
  IDynGridWizardChoiceData
}                                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {
  FieldService
}                                                                                  from '../../field-management/components/field.service';
import {
  ApGetCropService
}                                                                                  from '../../stores/services/ap-get-crop.service';
import {
  GetRoundNumericService
} from '../../ap-utils/service/get-round-numeric.service';
import {
  ApIcons
} from '../../ap-interface/enums/layout/ap-icons';
import {
  ApUtilService
} from '../../ap-utils/service/ap-util.service';
import {
  ApDateService
}                                                                                  from '../../ap-core/services/ap-date-service';
import {
  ApTranslationService
}                                                                                  from '../../ap-utils/service/ap-translation.service';
import {
  ApNutrientService
}                                                                                  from '../../ap-utils/service/ap-nutrient.service';
import {
  PpPlanningWizardComponent
}                                                                                  from '../../entry-components/plant-protection-entry-components/planning-wizard/pp-planning-wizard.component';
import {
  FormStore
}                                                                                  from '../../stores/layout/form.store';
import {ApGridPagerType, IGridPagerData}                                           from '../../ap-interface';
import {ObjectFactory}                                                             from 'ts-tooling';
import {
  FieldMassEditAction
}                                                                                  from '../../field-management/components/field-overview.component';
import {
  ApDynformsConfigFieldset
}                                                                                  from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsConfigNumerictextbox
}                                                                                  from '../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {
  ApDynformsValidator
}                                                                                  from '../../ap-dynforms/ap-dynforms-validator';
import {Validators}                                                                from '@angular/forms';
import {
  ApDynformsConfigPlaceholder
}                                                                                  from '../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {
  NotifyStore
}                                                                                  from '../../stores/dialog/notify.store';
import {
  PlantProtectionPlanBookStore
}                                                                                  from '../../stores/plant-protection/plant-protection-planbook.store';
import {
  AgriportConstantsService
}                                                                                  from '../../services/common/agriport-constants.service';
import {
  ApShowPointsOnMapService
}                                                                                  from '../../ap-utils/service/ap-show-points-on-map.service';
import {
  PlantProtectionService
}                                                                                  from '../../services/data/plant-protection.service';
import {
  IGridStatus
}                                                                                  from '../../ap-interface/interfaces/ap-grid-status.interface';
import IField = Data.FieldManagement.IField;
import IPlantProtectionPlanBook = Data.TaskManagement.IPlantProtectionPlanBook;
import IFieldGeom = Data.FieldManagement.IFieldGeom;

@Component({
  selector: 'plant-protection-overview',
  template: `
    <ap-dyncomponent [caption]="'Admin_Pages__Overview'"
                     [headerIcon]="'ap-fungidetect-icon'"
                     [columns]="columns"
                     [loading$]="loading$"
                     [details]="detailsColumns"
                     [items]="items$ | async"
                     [pager]="pager"
                     [canSearch]="true"
                     [canCreate]="true"
                     (create)="onCreate()">
    </ap-dyncomponent>
  `,
  styles: []
})
export class PpOverviewComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ApDynComponentComponent) dynComponent: ApDynComponentComponent;
  public columns: ApDynGridColumnConfigBase[] = [];
  public detailsColumns: ApDynGridDetailsGridConfig;
  public items$ = new BehaviorSubject<IPpOverviewGridItem[]>([]);
  public loading$: Observable<boolean>;
  public pager: ApDynGridPagerConfigBase;

  private _applyClicked = new EventEmitter<any>();
  private _subscriptions: Array<Subscription> = [];

  constructor(private campaignYearStore: CampaignYearStore,
              private cropTypeStore: CropTypeStore,
              private fieldStore: FieldStore,
              private notifyStore: NotifyStore,
              private formStore: FormStore,
              private cropService: ApGetCropService,
              private ppCommonService: PpCommonService,
              private fieldService: FieldService,
              private dateService: ApDateService,
              private nutrientService: ApNutrientService,
              private translationService: ApTranslationService,
              private roundNumericService: GetRoundNumericService,
              private ppOverviewGridConfig: PpOverviewGridConfig,
              private agriportConstantsService: AgriportConstantsService,
              private plantProtectionPlanBooksStore: PlantProtectionPlanBookStore,
              private showPointsOnMap: ApShowPointsOnMapService,
              private plantProtectionService: PlantProtectionService) {
  }

  public ngOnInit(): void {
    this.loading$ = combineLatest([
      this.plantProtectionPlanBooksStore.Listen(s => s.loading),
      this.cropTypeStore.Listen(s => s.loading),
      this.fieldStore.Listen(s => s.loading)
    ]).pipe(
      map(loadingItems => loadingItems.some(isLoading => isLoading))
    );
    this._subscriptions.push(this.campaignYearStore.Listen(s => s.selectedYear).subscribe(() => {
      this.plantProtectionPlanBooksStore.loadPlanBooks();
    }));
    this._subscriptions.push(this._buildItems().subscribe((items) => {
      this.items$.next(items);
    }));
    this.pager = this._buildPager();
    this._buildGrid();
  }

  public ngAfterViewInit(): void {
    this._subscriptions.push(combineLatest([
      this.dynComponent.gridSubject,
      this.formStore.FormClose$
    ]).pipe(filter(([grid]) => !!grid))
      .subscribe(([grid]) => grid.gridPaging.setSelectedKeys(this.fieldStore.getSelectedFieldIds())
      ));
    this._subscriptions.push(this.dynComponent.SelectedItems$.subscribe(items => {
      this.fieldStore.changeSelectedField(items.map(x => x.Id.toString()));
      if (items.length === 0) {
        this._onShowAll(this.items$.value);
        this.fieldStore.zoomFarmFields();
      } else if (items.length > 1) {
        this._onShowAll(items);
      }
    }));
    this._subscriptions.push(this._applyClicked.subscribe((e) => this._onApplyClicked(e)));
    this._subscriptions.push(this.fieldStore.Listen(x => x.fieldCropsSaved).subscribe(x => {
      this._invokeWhenFieldCropsUpdated(x);
    }));
  }

  public ngOnDestroy(): void {
    this.showPointsOnMap.clear();
    this.ppOverviewGridConfig?.destroy();
    this._subscriptions.forEach(d => d.unsubscribe());
  }

  /**
   * Opens the pp planning wizard
   * the preselection is handled in dynForm's selection change already
   */
  public onCreate(): void {
    this.formStore.openForm({component: PpPlanningWizardComponent, data: null});
  }

  private _buildGrid(): void {
    this.columns = this.ppOverviewGridConfig.getMainGridColumns();
    this.detailsColumns = this.ppOverviewGridConfig.getDetailsGridColumns(
      this.onShowPerPlanView.bind(this),
      this.onShowPerFieldView.bind(this)
    );
  }

  /**
   * Build the main grid items
   */
  private _buildItems(): Observable<IPpOverviewGridItem[]> {
    return combineLatest([
      this.plantProtectionPlanBooksStore.Listen(s => s.data),
      this.fieldStore.Listen(s => s.data),
      this.cropTypeStore.Listen(s => s.cropTypesNames)
    ]).pipe(
      filter(([planBooks, fields, cropTypesNames]) =>
        !!planBooks && !!fields && !!cropTypesNames),
      map(([planBooks, fields]) => {
        return fields.map<IPpOverviewGridItem>(field => {
          const geom = this.fieldStore.getCurrentFieldGeom(field);
          const applications = this._getApplications(field, planBooks);
          const mainCrop = this.cropService.parseMainCrop(field);
          const fieldCrop = mainCrop ? this.cropService.getFieldCrop(field) : null;
          // initialize a variable of the target type to keep it type-safe.
          // A cast ("as") does not ensure type safety
          const mainItem: IPpOverviewGridItem = {
            Id: field.Id,
            FieldCrop: fieldCrop,
            Status: this.getOverviewItemStatus(geom),
            Nr: field.FieldNumber,
            SNr: field.FieldSubnumber,
            NrSNr: this.fieldStore.getFieldNumberAndSubNumber(field),
            Name: field?.FieldName,
            Area: geom ? geom.AreaHa : undefined,
            Crop: mainCrop,
            EcValue: fieldCrop?.EcValue,
            CropNote: fieldCrop?.Note,
            Applications: applications
          };
          return mainItem;
        });
      }));
  }

  /**
   * Builds the details/applications data for each main row
   */
  private _getApplications(field: IField, planBooks: IPlantProtectionPlanBook[]): IPpOverviewDetailsGridItem[] {
    const result: IPpOverviewDetailsGridItem[] = [];
    if (!planBooks || planBooks.length <= 0 || !field) {
      return result;
    }
    result.AddRange(this.plantProtectionService.getPpApplications(field, planBooks)
      .map<IPpOverviewDetailsGridItem>(planBook => {
        const fieldGeom = this.fieldStore.getFieldGeomById(planBook.FieldGeomId);
        const area = this.roundNumericService.roundAsNumber(fieldGeom?.AreaHa ?? 0, 4);
        const appliedProducts = this.ppCommonService.getDistinctProductsOfPlanBooks([planBook]);
        const isWorkTypeSpraying = this.ppCommonService.isWorkTypeSpraying(planBook);
        const nUptakeValues = planBook.RasterStatistics.Find(s => s.Band === 0);
        const waterValues = planBook.RasterStatistics.Find(s => s.Band === 1);
        const detailItem: IPpOverviewDetailsGridItem = {
          Id: planBook.Id,
          FieldId: field.Id,
          Status: this.getDetailItemStatus(planBook),
          ApplNum: this.ppCommonService.getApplNumName(this.ppCommonService.getApplNumFromSummary(planBook.Summary)),
          OperationMode: this.translationService.translate(planBook.OperationMode?.Key),
          WorkArea: area,
          ApplDate: new Date(planBook.ApplicationDate),
          Ec: planBook.EcValue,
          NUptakeAvg: nUptakeValues?.Mean ?? PpNoDataValue,
          NUptakeMin: nUptakeValues?.Min ?? PpNoDataValue,
          NUptakeMax: nUptakeValues?.Max ?? PpNoDataValue,
          WaterAvg: waterValues?.Mean ?? isWorkTypeSpraying ? planBook.ApplicationRate : PpNoDataValue,
          WaterMin: waterValues?.Min ?? isWorkTypeSpraying ? planBook.ApplicationMin : PpNoDataValue,
          WaterMax: waterValues?.Max ?? isWorkTypeSpraying ? planBook.ApplicationMax : PpNoDataValue,
          Products: this.ppCommonService.getAppliedProductsExpr(appliedProducts, false, '; '),
          ProductsTooltip: this.ppCommonService.getAppliedProductsExpr(appliedProducts, true),
          CropKey: planBook.MainCropId,
          PlanId: planBook.Id as string,
        };
        return detailItem;
      }));
    return result;
  }

  private getOverviewItemStatus(fieldGeom: IFieldGeom | undefined): IGridStatus {
    const status = this.fieldService.getGeomStatus(fieldGeom, this.campaignYearStore.SelectedCampaignYear);
    return {
      state: status,
      class: status === 1 ? 'ap-status-green' : 'ap-status-red',
      description: '',
    };
  }

  private getDetailItemStatus(planBook: IPlantProtectionPlanBook | undefined): IGridStatus {
    const status = this.nutrientService.getFertilizerStatus(planBook?.Summary?.ApplicationMode, false);
    status.description = this.nutrientService.getFertilizerStatusDescription(planBook?.Summary?.ApplicationMode, false);
    return status;
  }

  private _buildPager(): ApDynGridPagerConfig {
    return new ApDynGridPagerConfig({
      apply: this._applyClicked,
      listMassEditing: [
        {
          id: FieldMassEditAction.EditMainCrop,
          type: ApGridPagerType.None,
          name: this.translationService.translate('Global__Edit'),
          onSubmit: this._applyClicked,
          formConfig: [
            new ApDynformsConfigFieldset({
              key: 'OverviewDetailsFieldSet',
              config: [
                new ApDynformsConfigNumerictextbox({
                  key: 'EcValueToUpdate',
                  label: 'ECStageShort',
                  min: +this.agriportConstantsService.GetConstant('GS_GLOBAL_MIN'),
                  max: +this.agriportConstantsService.GetConstant('GS_GLOBAL_MAX'),
                  decimals: 0,
                  format: 'n0',
                  validators: [
                    new ApDynformsValidator({validator: Validators.required, errorKey: ''})
                  ]
                }),
                new ApDynformsConfigPlaceholder()
              ]
            })
          ]
        } as IDynGridWizardChoiceData
      ],
      iconButtons: [
        {
          icon: ApIcons.PDF,
          callback: ApUtilService.createEventEmitter(this._onPdf.bind(this), this._subscriptions),
          tooltip: 'Global__Save_PDF'
        },
        {
          icon: ApIcons.XLS,
          callback: ApUtilService.createEventEmitter(this._onXls.bind(this), this._subscriptions),
          tooltip: 'Global__Save_EXCEL'
        }
      ]
    });
  }

  private _onApplyClicked(event: IGridPagerData): void {
    if (!event) {
      return;
    }
    if (event.object.id === PpOverviewMassEditAction.Edit) {
      const selectedFieldCrops = (this.dynComponent.getSelectedItems() as IPpOverviewGridItem[])
        .filter(x => x.FieldCrop)
        .map(x => x.FieldCrop);
      if (!selectedFieldCrops || selectedFieldCrops.length <= 0) {
        return;
      }
      const copiedFieldCrops = ObjectFactory.Copy(selectedFieldCrops);
      copiedFieldCrops.forEach(fieldCrop => {
        fieldCrop.EcValue = event.value ?? event.form['EcValueToUpdate'];
      });
      this.fieldStore.saveFieldCrops(copiedFieldCrops);
    }
  }

  private _invokeWhenFieldCropsUpdated(isUpdated: boolean | undefined): void {
    if (isUpdated === undefined) {
      return;
    }
    if (isUpdated) {
      this.notifyStore.showSaveSuccessMessage();
    } else {
      this.notifyStore.showSaveFailMessage();
    }
  }

  private _onPdf(): void {
    this.dynComponent.dynGrid.pdfExportFileName = this._generatePrintFilename();
    this.dynComponent.dynGrid.exportAsPdf();
  }

  private _onXls(): void {
    this.dynComponent.dynGrid.xlsExportFileName = this._generatePrintFilename();
    this.dynComponent.dynGrid.exportAsXls();
  }

  private _generatePrintFilename(): string {
    return `${this.dateService.toFarmDate(new Date()).format('YYYY-MM-DD')}_` +
      `${this.translationService.translate('Global__Plant_Protection')}_` +
      `${this.translationService.translate('Admin_Pages__Overview')}`;
  }

  private onShowPerPlanView(dataItem: IPpOverviewDetailsGridItem): void {
    const summary = this.plantProtectionPlanBooksStore.PlanBooks.find(x => x.Id === dataItem?.PlanId)?.Summary;
    if (!summary) {
      return;
    }
    const relatedPlanBooks = this.plantProtectionPlanBooksStore.PlanBooks.filter(x => x.Summary.Id === summary.Id && !!x.BookedAt);
    const rasterData = relatedPlanBooks.map(x => ({
      FieldId: x.FieldId.toString(),
      PlanBookId: x.Id.toString()
    }));
    this.showPointsOnMap.showAllRaster(rasterData, 'pp');
    this.dynComponent.dynGrid.gridPaging.setSelectedKeys(rasterData.map(x => x.FieldId));
  }

  private onShowPerFieldView(dataItem: IPpOverviewDetailsGridItem): void {
    if (!dataItem?.FieldId || !dataItem?.PlanId) {
      return;
    }
    const fieldIdString = dataItem.FieldId.toString();
    this.showPointsOnMap.showRaster(fieldIdString, dataItem.PlanId.toString(), 'pp');
    this.dynComponent.dynGrid.gridPaging.setSelectedKeys([fieldIdString]);
  }

  private _onShowAll(items: IPpOverviewGridItem[], applicationMap: { [fieldId: string]: any } = {}): void {
    if (!items) {
      return;
    }
    items
      .map((i) => i.Applications as IPpOverviewDetailsGridItem[])
      .flat()
      .forEach((other: IPpOverviewDetailsGridItem) => {
        const fieldId = other.FieldId.toString();
        if (applicationMap[fieldId] !== undefined) {
          if (other.ApplDate.valueOf() > applicationMap[fieldId].ApplDate.valueOf()) {
            applicationMap[fieldId] = other;
          }
        } else {
          applicationMap[fieldId] = other;
        }
      });
    const showRaster = Object.keys(applicationMap).map((key) => ({
      FieldId: key,
      PlanBookId: applicationMap[key].PlanId
    }));
    this.showPointsOnMap.showAllRaster(showRaster, 'pp');
  }
}
